//
import * as i18nFiles from './translationModules';

let en_US = {};
let es_US = {};
let en_CA = {};
let fr_CA = {};

export type MyPriModules = keyof typeof i18nFiles;

const arrayOfModules = Object.keys(i18nFiles) as Array<keyof typeof i18nFiles>;

arrayOfModules.forEach((module) => {
  // eslint-disable-next-line import-x/namespace
  const moduleData = i18nFiles[module];
  en_US = { ...en_US, ...moduleData.en_US };
  es_US = { ...es_US, ...moduleData.es_US };
  en_CA = { ...en_CA, ...moduleData.en_CA };
  fr_CA = { ...fr_CA, ...moduleData.fr_CA };
});

export default {
  en_US,
  es_US,
  en_CA,
  fr_CA,
};
